import { fetchApiData } from "../../utils/utils";

export const getAllVideosOfPlayList = async (appInfo,id) =>{
    
    const api = `playlist/${id}`
    return await fetchApiData(appInfo,api)
}